import { Component, Inject, Optional } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { MatSnackBar } from '@angular/material/snack-bar';
import { RecordService } from '../../services/record.service';

export interface UsersData {
  name: string;
  id: number;
}


@Component({
  selector: 'app-cancel-reassing-record',
  templateUrl: './cancel-reassing-record.component.html',
  styleUrls: ['./cancel-reassing-record.component.css']
})
export class CancelReassignRecordComponent {

  action: string;
  local_data: any;
  appointment: any;
  reassign: boolean = false;
  dateFrom: any;
  checked = false;
  minDate = new Date();

  constructor(
    public dialogRef: MatDialogRef<CancelReassignRecordComponent>,
    private snackBar: MatSnackBar,
    private recordService: RecordService,
    // @Optional() is used to prevent error if no data is passed
    @Optional() @Inject(MAT_DIALOG_DATA) public data: UsersData) {
    this.appointment = { ...data };
    if(this.appointment && this.appointment.cancelNote){
      this.appointment.cancelNote = "";
    }
    
  }

  snackBarMessage(msg: any, duration: any) {
    this.snackBar.open(msg, '', {
      duration: duration, panelClass: ['blue-snackbar']
    });
  }

  doAction() {
    if (this.appointment.cancelNote) {
      if (this.reassign) {
        this.appointment.dateFrom = this.dateFrom;
      }
      this.recordService.cancelCertificateAppointment(this.appointment.id, this.appointment, this.reassign).subscribe((response: any) => {
        if (this.reassign) {
          this.snackBarMessage('Se reasignó el turno exitosamente', 5000);
          this.clean();

        } else {
          this.snackBarMessage('Se canceló el turno exitosamente', 5000);
          this.clean();
        }

      }, (e: any) => {
        if (e.status === 409) {
          this.snackBarMessage(e.error.message, 5000);
        } else {
          this.snackBarMessage('Ocurrió un problema', 5000);
        }
      });

      this.dialogRef.close({ event: 'Accept' });
    } else {
      this.snackBarMessage('¡El motivo de cancelación es obligatorio!', 5000);
    }
  }

  closeDialog() {
    this.dialogRef.close({ event: 'Cancel' });
  }

  changed() {
    if (!this.reassign) {
      this.dateFrom = "";
    }
  }

  clean() {
    this.reassign = false;
    this.appointment = {}
  }


}
